import { Component, HostListener, Inject, OnDestroy, OnInit, VERSION } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, AuthError, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { b2cPolicies, environment as env, myBGCAppId } from '@env';
// rxjs
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { IconService } from './registered-user/core/services/icon.service';
import { SessionSecurityService, AuditHistoryService, MemberSearchService } from '@shared/services';
import { AppAuditLog } from '@core/models'; 


interface IdTokenClaims extends AuthenticationResult {
  idTokenClaims: {
    acr?: string,
    role?: string
  }
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {
  isProd = env.production;
  year = new Date().getFullYear();

  languages = ['en', 'no'];

  //isAuthenticated$: Observable<boolean>;

  // private subs = new SubSink();

  title = 'myBGCA';

  //subscriptions: Subscription[] = [];
  loginDisplay = false;
  isIframe = false;
  loggedIn = false;
  notAnonymousLogin = false;
  istermsandlegal = false;
  currentRoute: string;
  anonymousUrls = ['registration', 'boardRegistration', 'termsofuse', 'legalpolicy','findusers', 'faq','deleteuser'];
  private readonly _destroying$ = new Subject<void>();

  scrHeight:any;
  scrWidth:any;

  //model for app launch log data
  appAuditData: AppAuditLog;
  propsToShow = ['userAgent', 'os', 'browser', 'device', 'os_version', 'browser_version', 'deviceType', 'orientation'];
  deviceInfo = null;
  version = VERSION.full;
  userAgentInputVal = null;
  ua;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private iconService: IconService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private sessionSecurity: SessionSecurityService,
    private auditHistoryService: AuditHistoryService,
    private memberSearchService: MemberSearchService,
    private activatedRoute: ActivatedRoute 
  ) { 
    // try {
    //   this.ua = window.navigator.userAgent;
    // } catch {
    //   console.log('UA not available');
    // }
    //this.applyDevice();
   }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;

        if(this.scrWidth > 600)
          this.sessionSecurity.setObject('Desktop', 'Device');
        else if(this.scrWidth > 400) 
          this.sessionSecurity.setObject('Tablet', 'Device');
        else
          this.sessionSecurity.setObject('Mobile', 'Device');
  }

  ngOnInit() {
    // Immediately resolve anonymous routes before any async events fire
    const initialPath = window.location.pathname.split('/').filter(Boolean)[0] ?? '';
    if (this.anonymousUrls.some(url => url === initialPath)) {
      this.loggedIn = true;
    }

    this.router.events.subscribe((val) => {
      if (val instanceof ActivationEnd) {
          this.currentRoute = val.snapshot.routeConfig?.path;
          this.isAnonymous();
      }
    });
    
    
    this.isIframe = window !== window.parent && !window.opener;
    this.sessionSecurity.setObject('false', 'LoggedIn');
    
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.isAnonymous();
        this.checkAccount();
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {       
        let payload: IdTokenClaims = <AuthenticationResult>result.payload; 
        if(this.authService.instance.getAllAccounts().length > 0)
        {
          this.sessionSecurity.setObject(payload.accessToken, 'iBGCA.idtoken');
          this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]); 
        }
        const account: any = this.authService.instance.getActiveAccount();
 
        var disableAccountToken = account.idTokenClaims["disabledLogin"]; 
        var disableAccountCheck = true;
        if (disableAccountToken == disableAccountCheck) {
          account.idTokenClaims["disabledLogin"]=false;
          // console.log(disableAccountToken);
          this.router.navigate(['/user-profile', account.idTokenClaims["sub"], 0]);
          //return;
        }

        // debugger;
       //  console.log(router.errorHandler);
        // this.activatedRoute.fragment.subscribe(paramsÂ =>Â {
        //  if(params&&params?.split('=').length>0)
        //  {
        //    this.router.navigate(['/user-profile', account.idTokenClaims["sub"],0]);
        //  }
        // })
        // We need to reject id tokens that were not issued with the default sign-in policy.
        // "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr")
        // To learn more about b2c tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview

        if (payload.idTokenClaims?.acr === b2cPolicies.names.resetPassword) {
          window.alert('Password has been reset successfully. \nPlease sign-in with your new password.');
          return this.authService.logoutRedirect();
        } else if (payload.idTokenClaims['acr'] === b2cPolicies.names.editProfile) {
          window.alert('Profile has been updated successfully. \nPlease sign-in again.');
          return this.authService.logoutRedirect();
        }

        if(result.eventType === EventType.LOGIN_SUCCESS) {
          this.memberSearchService.getUserInfoValue().pipe(takeUntil(this._destroying$)).subscribe((value) => {
            if(value) {
              const userId: string = this.sessionSecurity.getObjectLocalStorage('UserId');
              const userEmail: string = this.sessionSecurity.getObjectLocalStorage('UserEmail');
              this.appAuditData = {
                userId: userId,
                emailId: userEmail,
                applicationId: myBGCAppId.applicationId,
                clientId: myBGCAppId.clientId,
                applicationName: 'MyBGCA.Net',
                action: 0 //this flag denotes app login
              }
      
              //api call to log application logout
              this.auditHistoryService.createApplicationAuditLog(this.appAuditData)
                .subscribe(response => {
                  console.log(response);
                  this.sessionSecurity.deleteObjectLocalStorage('UserId');
                  this.sessionSecurity.deleteObjectLocalStorage('UserEmail');
              });
            }
          });
        }

        return result;
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        console.error('MSAL auth failure:', result.eventType, result.error);
        if (result.error instanceof AuthError) {
          // Only handle password reset — do NOT call this.login() on generic failures
          // because that causes an infinite redirect loop when MSAL itself has an error.
          if (result.error.message.includes('AADB2C90118')) {
            this.login({
              scopes: ["openid"],
              authority: b2cPolicies.authorities.resetPassword.authority
            });
          }
          // All other errors: log only. MsalGuard will handle re-authentication.
        }
      });

      this.iconService.init();
      this.sessionSecurity.setObject('false', 'UserApproved');
  }

  clearStorage(){
    sessionStorage.clear();
  }
   

  checkAccount() {  

    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.notAnonymousLogin = true;
    if(this.loginDisplay === true)
    {
      this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]);
      this.sessionSecurity.setObject('true', 'LoggedIn');
      this.loginValidation();
    }else{
      this.sessionSecurity.setObject('false', 'LoggedIn');
    }
    
  
  }
    
  isAnonymous(){
    const route = this.currentRoute ?? '';
    if(!this.anonymousUrls.some(role => role.includes(route))){
      this.getScreenSize();
      this.loginValidation();
    }else{
      this.loggedIn = true;
    }
  }

  loginValidation(){
    let isLogin = this.sessionSecurity.getObject('LoggedIn');
    if(this.loginDisplay)
      this.loggedIn = isLogin == "true"? true : false;
    else
      this.loggedIn = false;
  }

  login(userFlowRequest?: RedirectRequest | PopupRequest) {
 
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup(userFlowRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect(userFlowRequest);
      }
    }
  }

  logout() {
    
    this.clearStorage();
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  editProfile() {
    
    let editProfileFlowRequest = {
      scopes: ["openid"],
      authority: b2cPolicies.authorities.editProfile.authority,
    };

    this.login(editProfileFlowRequest);
  }

  ngOnDestroy(): void {
    this.clearStorage();
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
